/**
 * Redux slice for meetings page state.
 * Stores todayQueryArgs so the meeting detail can reuse the same RTK Query args
 * as useSearchData and get a cache hit (no duplicate request, no list remount).
 */
import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'meetingsPage',
  initialState: {
    todayQueryArgs: null,
    openMeetingDate: null,
    scrollAnchorDate: null,
    viewDateLabelPinned: false,
    // Sync fallback while view_date URL param catches up after selectDate.
    pinnedPickDate: null,
  },
  reducers: {
    setTodayQueryArgs: (state, action) => {
      state.todayQueryArgs = action.payload
    },
    // Cleared when the user picks a date or changes preset; not driven by the right rail.
    setOpenMeetingDate: (state, action) => {
      state.openMeetingDate = action.payload
    },
    // Display-only date from scroll position (date group closest to viewport center). Does not
    // change the view_date URL param or re-query the feed.
    setScrollAnchorDate: (state, action) => {
      state.scrollAnchorDate = action.payload
    },
    // When true, the date picker label stays on the picked date until the user scrolls —
    // prevents scroll-sensor reads from jumping the label during pivot load / scroll-to-date.
    setViewDateLabelPinned: (state, action) => {
      state.viewDateLabelPinned = action.payload
      if (!action.payload) {
        state.pinnedPickDate = null
      }
    },
    setPinnedPickDate: (state, action) => {
      state.pinnedPickDate = action.payload
    },
  },
})

export const {
  setTodayQueryArgs,
  setOpenMeetingDate,
  setScrollAnchorDate,
  setViewDateLabelPinned,
  setPinnedPickDate,
} = slice.actions
export const todayQueryArgsSelector = (state) => state.meetingsPage?.todayQueryArgs ?? null
export const openMeetingDateSelector = (state) => state.meetingsPage?.openMeetingDate ?? null
export const scrollAnchorDateSelector = (state) => state.meetingsPage?.scrollAnchorDate ?? null
export const viewDateLabelPinnedSelector = (state) => state.meetingsPage?.viewDateLabelPinned ?? false
export const pinnedPickDateSelector = (state) => state.meetingsPage?.pinnedPickDate ?? null
export const reducer = slice.reducer
